export enum Category {
  notice = '공지'
}

export enum AnotherCategory {
  notice = '공지'
}
